import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/App";
import { configureAmplify } from "@/lib/amplify";
// Self-hosted variable fonts (ui.md §2a). Geist + Geist Mono — MIT-licensed,
// designed for data-dense dashboards; tabular numerals are enabled at the
// root selector in globals.css.
import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "@/styles/globals.css";
// Product-tour theming (driver.js base + our token overrides). Loaded
// once at bootstrap so the GettingStartedPage tour launcher renders
// styled popovers without per-page CSS imports.
import "@/lib/tour/styles.css";

// Configure Amplify once, synchronously, before React mounts so every
// component tree sees a ready Cognito client. Skipped silently if env vars
// are absent (dev with a half-populated .env.local).
configureAmplify();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
